var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dynamic-article-tabs" },
    [
      _c("header", { staticClass: "dynamic-article-tabs-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c("dynamic-tabs-nav", {
        attrs: {
          label: _vm.navLabel,
          links: _vm.links,
          "active-link": _vm.activeTag
        },
        on: { select: _vm.changeArticles, "show-all": _vm.showAll }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "dynamic-article-tabs-content-grid" },
        _vm._l(_vm.activeArticles, function(article) {
          return _c("article-excerpt", {
            key: article.id,
            attrs: {
              id: article.id,
              title: article.title,
              "image-src": article.imageSrc,
              meta: article.meta,
              url: article.url,
              excerpt: article.excerpt,
              "read-more-label": _vm.readMoreLabel,
              "image-placeholder": _vm.imagePlaceholder,
              "published-date": article.publishedDate,
              "can-show-published-date": _vm.canShowPublishedDate
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "footer",
        [
          _vm.activePageCount > 1
            ? _c("dynamic-tabs-pagination", {
                ref: "pagination",
                attrs: {
                  "prev-label": _vm.prevLabel,
                  "next-label": _vm.nextLabel,
                  "page-count": _vm.activePageCount,
                  "current-page": _vm.currentPage
                },
                on: { "change-page": _vm.changePage }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }